export default [{
    path: '/system/rules/costCenter',
    component: resolve => require(['./rules/costCenter.vue'], resolve)
  },{
    path: '/system/rules/projectCode',
    component: resolve => require(['./rules/projectCode.vue'], resolve)
  }, {
    path: '/system/rules/contraryReason',
    component: resolve => require(['./rules/contraryReason.vue'], resolve)
  }, {
    path: '/system/rules/travelPurpose',
    component: resolve => require(['./rules/travelPurpose.vue'], resolve)
  }, {
    path: '/login',
    component: resolve => require(['./user/login.vue'], resolve)
  }, {
    path: '/VerificationLogin',
    component: resolve => require(['./user/VerificationLogin.vue'], resolve)
  }, {
    path: '/Register',
    component: resolve => require(['./user/Register.vue'], resolve)
  }, {
    path: '/businessRegister',
    component: resolve => require(['./user/businessRegister.vue'], resolve)
  }
  , {
    path: '/system/user/main',
    component: resolve => require(['./user/main.vue'], resolve)
  }, {
    path: '/system/user/account',
    component: resolve => require(['./user/account/account.vue'], resolve)
  }, {
    path: '/system/user/editProfile',
    component: resolve => require(['./user/account/editProfile.vue'], resolve)
  }, {
    path: '/system/user/accountRelating',
    component: resolve => require(['./user/account/accountRelating.vue'], resolve)
  }, {
    path: '/system/user/editPassword',
    component: resolve => require(['./user/account/editPassword.vue'], resolve)
  },
  {
    path: '/system/user/notice',
    component: resolve => require(['./user/notice.vue'], resolve)
  }, {
    path: '/reset',
    component: resolve => require(['./user/reset.vue'], resolve)
  }, {
    name: 'BindingAccount',
    path: '/system/user/bindingAccount',
    component: resolve => require(['./user/account/BindingAccount.vue'], resolve)
  }, {
    name: 'approvalSetList',
    path: '/system/approvalSet/list',
    component: resolve => require(['./approvalSet/list.vue'], resolve)
  },
  // {
  //   name: 'approvalSetDetail',
  //   path: '/system/approvalSet/detail',
  //   component: resolve => require(['./approvalSet/detail.vue'], resolve)
  // },
  {
    name: 'download',
    path: '/system/download',
    component: resolve => require(['./download/download.vue'], resolve)
  },
  {
    name: 'about',
    path: '/system/about',
    component: resolve => require(['./about/about.vue'], resolve)
  },
  {
    name: 'privacyPolicy',
    path: '/system/privacyPolicy',
    component: resolve => require(['./about/privacyPolicy.vue'], resolve)
  },
  {
    name: 'notify',
    path: '/system/notify',
    component: resolve => require(['./notify/notify.vue'], resolve)
  },
  {
    name: 'messageNotify',
    path: '/system/messageNotify',
    component: resolve => require(['./messageNotify/messageNotify.vue'], resolve)
  },
  {
    name: 'feedBack',
    path: '/system/feedBack',
    component: resolve => require(['./feedBack/feedBack.vue'], resolve)
  },
  {
    name: 'configInfo',
    path: '/system/configInfo',
    component: resolve => require(['./configInfo/configInfo.vue'], resolve)
  },
  
  //  {
  //   name: 'WeChatAuthorizat',
  //   path: '/system/WeChatAuthorizat',
  //   component: resolve => require(['./WeChatAuthorizat/WeChatAuthorizat.vue'], resolve)
  // },
  
  
]



// WEBPACK FOOTER //
// ./src/views/system/router.js